import React from 'react';
import TransportCards from '../../../react4xp/components/TransportCards'

function TransportCardsPart({title, topLine, transportCards, backgroundColor}) {
	return <TransportCards
		line={topLine}
		title={title}
		cards={transportCards?.map((card) => ({
			title: card.title,
			intro: card.intro,
			link: (card.target || card.externalLink) && {
				href: card.target || card.externalLink,
				external: !card.target,
				stayInTab: card.stayInTab
			},
			cardColor: backgroundColor
		}))}
	/>
}

export default (props) => <TransportCardsPart {...props} />
